import {
  UPDATE_FULL_RANGE_DATA_DUMP_FOR_PROCESSES,
  UPDATE_DATA_DUMP_FOR_PROCESS,
} from "providers/GlobalStateProvider";
import DataDumpGetter from "segments/DataDumpGetter/DataDumpGetter";
import {
  useFocusRange,
  useGetPageFromPath,
} from "utils/customHooks/genericHooks";
import { useForceRerenderOnIntervalIfCurrentRange } from "./useForceRerenderOnIntervalIfCurrentRange";
import { useProcessIdsForDataDumpFullRange } from "./useProcessIdsForDataDumpFullRange";
import { useCallback } from "react";
import { DataDumpAggregateType } from "types/types";
import { useDispatch } from "react-redux";
import { useCleanRawDataDump } from "segments/DataDumpGetter/dataDumpGetterUtils";

export function DataDumpGetterForFullRange() {
  const focusRange = useFocusRange();

  const processIdsForDataDumpFullRange = useProcessIdsForDataDumpFullRange();
  const randKey = useForceRerenderOnIntervalIfCurrentRange();

  const { isHubletPage } = useGetPageFromPath();
  const dispatch = useDispatch();
  const cleanRawDataDump = useCleanRawDataDump();
  const onAfterCompleted = useCallback(
    (data: { dataDumpAggregate: DataDumpAggregateType }) => {
      // on Hublet page, economize on network requests by only fetching the data for the current process -> store this in fullRangeDataDumpForProcesses
      if (isHubletPage) {
        const dataDumpObj = cleanRawDataDump(
          data.dataDumpAggregate,
          processIdsForDataDumpFullRange
        );
        dispatch({
          type: UPDATE_DATA_DUMP_FOR_PROCESS,
          payload: {
            dataDumpObj,
            processId: processIdsForDataDumpFullRange[0],
          },
        });
      }
    },
    [isHubletPage, processIdsForDataDumpFullRange, dispatch, cleanRawDataDump]
  );

  return (
    <DataDumpGetter
      key={randKey}
      timeRange={focusRange}
      processIds={processIdsForDataDumpFullRange}
      dataDumpAggType={UPDATE_FULL_RANGE_DATA_DUMP_FOR_PROCESSES}
      customAfterCompleted={onAfterCompleted}
    />
  );
}
